// extracted by mini-css-extract-plugin
module.exports = {"memoList":"memoList_memoList__2prsJ","item":"memoList_item__vgqfd","time":"memoList_time__2RWds","memoCon":"memoList_memoCon__38nU6"};